import { useMemo } from 'react'
import { useAuthenticateUser } from '@/components/ui/AuthButton/hooks'
import { useData } from '@/logic/data'
import type { IUseDataOptions } from '@/logic/data/interfaces'
import type { IStore, IStoreLocation } from '@/types/IStore'

const defaultUserStore: IStore[] = []

export interface ICustomUserStore extends IStoreLocation {
  id: string
}

export const useUserStores = (options: IUseDataOptions = {}) => {
  const { isAuthenticated } = useAuthenticateUser()

  const { data: userStores = defaultUserStore, isLoading: isLocationsLoading } = useData<IStore[]>('stores', {
    ...options,
    shouldNotLoadDataOnMount: !isAuthenticated,
  })
  const locations: ICustomUserStore[] = useMemo(() => userStores.map(({ id, location }) => ({ ...location, id })), [userStores])

  return {
    isLocationsLoading,
    locations,
    userStores,
  }
}
